export default "__VITE_ASSET__B2tsGQPc__"